import { ICarePerformer } from "../models/ICarePerformer";
import * as Utils from "../utils/Config";
import { ApiClient } from "./ApiClient";

export class CarePerformerApi extends ApiClient {

    getCarePerformersToday(success: (data: ICarePerformer[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICarePerformer[]>(`${Utils.LIB_API_BASE_URL}/carePerformers/getCarePerformersToday`, success, error, final);
    }

    getCarePerformerDentistsToday(success: (data: ICarePerformer[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICarePerformer[]>(`${Utils.LIB_API_BASE_URL}/carePerformers/getCarePerformerDentistsToday`, success, error, final);
    }

    getCarePerformersWithDate(date: string, success: (data: ICarePerformer[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICarePerformer[]>(`${Utils.LIB_API_BASE_URL}/carePerformers/getCarePerformersWithDate/${date}`, success, error, final);
    }

    getCarePerformerDentistsWithDate(date: string, success: (data: ICarePerformer[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICarePerformer[]>(`${Utils.LIB_API_BASE_URL}/carePerformers/getCarePerformerDentistsWithDate/${date}`, success, error, final);
    }

    getCarePerformerDentistsWithDateAndSpeciality(date: string, specialityId: number, success: (data: ICarePerformer[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICarePerformer[]>(`${Utils.LIB_API_BASE_URL}/carePerformers/getCarePerformerDentistsWithDateAndSpeciality/${date}/${specialityId}`, success, error, final);
    }

    getCarePerformerDentalHygienistsToday(success: (data: ICarePerformer[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICarePerformer[]>(`${Utils.LIB_API_BASE_URL}/carePerformers/getCarePerformerDentalHygienistsToday`, success, error, final);
    }

    getCarePerformerDentalHygienistsWithDate(date: string, success: (data: ICarePerformer[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICarePerformer[]>(`${Utils.LIB_API_BASE_URL}/carePerformers/getCarePerformerDentalHygienistsWithDate/${date}`, success, error, final);
    }

    getCarePerformerWithDate(date: string, success: (data: ICarePerformer[]) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICarePerformer[]>(`${Utils.LIB_API_BASE_URL}/carePerformers/getCarePerformerWithDate/${date}`, success, error, final);
    }

    getCarePerformerWithId(carePerformerId: number, success: (data: ICarePerformer) => void, error?: (message: string) => void, final?: () => void) {
        this.get<ICarePerformer>(`${Utils.LIB_API_BASE_URL}/carePerformers/${carePerformerId}`, success, error, final);
    }
}